<template>

  <div class="overflow-auto" v-if="hasNext || hasPref || hasFirst">
    <nav>
      <ul class="pagination justify-content-center">
        <li :class="{'page-item': true, 'disabled': !hasFirst}">
          <router-link :to="{name: routeName, params: routeParams, query: firstParams}" class="page-link" title="Самые новые">
            <fa-icon icon="angle-double-left" />
          </router-link>
        </li>
        <li :class="{'page-item': true, 'disabled': !hasPrev}">
          <router-link :to="{name: routeName, params: routeParams, query: prevParams}" class="page-link">
            <fa-icon icon="angle-left" /> Назад
          </router-link>
        </li>
        <li :class="{'page-item': true, 'disabled': !hasNext}">
          <router-link :to="{name: routeName, params: routeParams, query: nextParams}" class="page-link">
            <fa-icon icon="angle-right" /> Вперёд
          </router-link>
        </li>
        <li :class="{'page-item': true, 'disabled': !hasLast}">
          <router-link :to="{name: routeName, params: routeParams, query: lastParams}" class="page-link" title="Самые старые">
            <fa-icon icon="angle-double-right" />
          </router-link>
        </li>
      </ul>
    </nav>
  </div>

</template>

<script>
export default {
    name: 'KeysetPagination',
    props: [
        'routeName',
        'routeParams',
        'prevId',
        'nextId',
        'query'
    ],
    methods: {
        getQuery () {
            if (!this.query) {
                return {};
            }
            return Object.assign({}, this.query);
        }
    },
    computed: {
        hasFirst () {
            return !(!Object.prototype.hasOwnProperty.call(this.query, 'from-id') &&
                     !Object.prototype.hasOwnProperty.call(this.query, 'to-id'));
        },
        hasNext () {
            return this.nextId;
        },
        hasPrev () {
            return this.prevId;
        },
        hasLast () {
            return this.hasNext && (
                !Object.prototype.hasOwnProperty.call(this.query, 'to-id') ||
                this.query['to-id'] != 0
            );
        },
        firstParams () {
            const q = this.getQuery();
            delete q['from-id'];
            delete q['to-id'];
            return q;
        },
        lastParams () {
            const q = this.getQuery();
            delete q['from-id'];
            q['to-id'] = 0;
            return q;
        },
        nextParams () {
            const q = this.getQuery();
            delete q['to-id'];
            q['from-id'] = this.nextId;
            return q;
        },
        prevParams () {
            const q = this.getQuery();
            delete q['from-id'];
            q['to-id'] = this.prevId;
            return q;
        }
    }
}

</script>
